import Client from '../HttpClient';

const numbatUrl = '/gateway/numbat-api/api/vs/manage-config/sysParameter';
const getSelfRichText = (type) => {
	return Client.get(`/admin/api/self`);
};
const getSelfRichTextCloud = (merchantId, branchId, type) => {
	return Client.get(`${numbatUrl}/${merchantId}/${branchId}/self`);
};

const updateSelfRichText = (val) => {
	return Client.put('/admin/api/self', val);
};
const updateSelfRichTextCloud = (merchantId, branchId, val) => {
	return Client.put(`${numbatUrl}/${merchantId}/${branchId}/self`, val);
};

export default {
	getSelfRichText,
	updateSelfRichText,
	getSelfRichTextCloud,
	updateSelfRichTextCloud,
};
